<template>
  <div>
    <div class="input-group mb-3">
      <input v-model="coordinates" type="text" class="form-control" readonly>
      <div class="input-group-append">
        <div class="btn map-btn" @click="show">
          <font-awesome-icon icon="map-marker-alt"/>
        </div>
      </div>
    </div>
    <machine-map v-if="showMap" :value="value" @input="onInput"></machine-map>
  </div>
</template>

<script>
  import MachineMap from './map.vue'

  export default {
    components: {
      MachineMap,
    },
    props: ['value'],
    data () {
      return {
        showMap: false,
      }
    },
    methods: {
      show () {
        this.showMap = !this.showMap
      },
      onInput (value) {
        this.$emit('input', value)
      },
    },
    computed: {
      coordinates () {
        return this.value ? `${this.value.lat},${this.value.lon}` : ''
      },
    },
    watch: {
//      coordinates (n, o) {
//        if (n !== o) {
//          const data = this.coordinates.split(',', 2).filter((el) => !isNaN(el))
//          if (data.length === 2) {
//            this.location = {
//              lat: data[0],
//              lon: data[1],
//            }
//          }
//        }
//      },
    },
  }
</script>

<style lang="scss">
  @import "boot";

  .map-btn {
    border-color: $primary;

    &:hover, &:focus {
      background: $gray-200;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/machines/map-input.vue